import { createSlice } from '@reduxjs/toolkit';
import { getLiteImages } from '../../../rtk-apis/reports/getLiteImages';

const initialState = {
  status: '',
  data: [],
  msg: '',
  loading: false,
};

const getLiteImagesSlice = createSlice({
  name: 'getLiteImagesSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = [];
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getLiteImages.pending, state => {
        state.loading = true;
        state.status = 'pending';
      })
      .addCase(getLiteImages.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'fulfilled';
        state.data = action?.payload?.data || [];
        state.msg = action?.payload?.msg || 'Lite images fetched successfully';
      })
      .addCase(getLiteImages.rejected, (state, action) => {
        state.loading = false;
        state.status = 'rejected';
        state.data = [];
        state.msg = (action?.payload as string) || 'Failed to fetch lite images';
      });
  },
});

export const { clearState } = getLiteImagesSlice.actions;
export default getLiteImagesSlice.reducer;
